<template>
    <transition name="modal">
        <div class="popup-mask">
            <div class="popup-wrapper">
                <div class="popup-container" >

                    <div class="x-button" v-if="xClose">
                        <a v-on:click.self="btnClick" style="color:black;">X</a>
                    </div>
                    <div class="popup-header">
                        <h4 class="h4">{{ this.title }}</h4>
                    </div>

                    <div class="popup-body">
                        <slot name="content"></slot>
                    </div>

                    <div class="popup-footer">
                        <slot name="footer">
                            <button class="button" @click="$emit('close')" v-if="xClose === 'false'">
                                Ok
                            </button>
                            <div class="inner" v-if="dataStoreModal">
                                <div class="mod" style="text-align: center">
                                    <button id="yes-button" class="button button--no-break"  @click="agree()" style="background-color: red; margin-right: 10px;">Yes</button>
                                    <button id="no-button" class="button button--no-break" style="margin-left: 10px" @click="cancel()">No</button>
                                </div>
                            </div>
                            <div>

                            </div>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import {bus} from "../app";

    export default {
        name: "PopupModal",
        props: {
            title: String,
            xClose: Boolean,
            dataStoreModal: Boolean,
        },
        data() {
            return {
                id: ''
            }
        },
        methods: {
            btnClick: function() {
                this.$emit('close');
            },
            agree: function() {
                bus.$emit('agree', this.id);
                window.vm1.showModal = false;
            },
            cancel: function() {
                window.vm1.showModal = false;
            }
        },
        created() {
            bus.$on('showStateModal', (id) => {
                this.id = id;
                document.getElementById('modal-text').innerHTML = "You have at least one county belonging to this state in your cart. Are you sure you want to add this state to your cart?";
                window.vm1.showModal = true;
            });
            bus.$on('showCountyModal', (id) => {
                this.id = id;
                document.getElementById('modal-text').innerHTML = "This county is included with purchase of the state bundle already in your cart. Are you sure you want to add this county to your cart? ";
                window.vm1.showModal = true;
            });
        },
    }
</script>

<style scoped>
    .popup-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .popup-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .popup-container {
        max-width: 75%;
        max-height: calc(100vh - 50px);
        margin: 0 auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
    }

    .popup-header h4 {
        margin-top: 0;
        color: #42b983;
    }

    .popup-body {
        margin: 20px 0;
        max-height: calc(100vh - 150px);
        overflow-y: auto;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .popup-container,
    .modal-leave-active .popup-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .x-button {
            max-width: 100%;
            text-align: right;
    }

    .x-button:hover {
        cursor: pointer;
    }

    .h5 {
        font-size: 34px;
    }

</style>
